<template>
  <div id="menu">
    <div class="header">
      <GameSelect />
      <button @click="handleClose">
        <img class="menu-toggler" src="@/asset/icon/menu-toggler-x.svg" alt="toggle menu">
      </button>
    </div>

    <div v-if="!logged" class="login">
      <button class="btn btn-primary sign-in" @click="pushRoute({ name: ROUTE.login })">
        <img src="@/asset/icon/social/steam.svg" width="27" height="16" class="icon" alt="">
        <span>{{ $t('login.sign_in') }}</span>
      </button>
      <button class="btn btn-primary sign-up" @click="pushRoute({ name: ROUTE.register })">
        <img src="@/asset/icon/social/steam.svg" width="27" height="16" class="icon" alt="">
        <span>{{ $t('login.sign_up') }}</span>
      </button>
    </div>

    <div class="issues">
      <SteamDown v-if="steam_down && steam_down_hide" :click-action="false" />
      <HotNotify v-if="hot_notify_enabled && !hot_notify_visible" :click-action="false" />
    </div>

    <BamLink v-if="logged" :to="ROUTE.profile" class="header-avatar-menu">
      <span class="user-name">{{ unescapeNickname(profile.username) }}</span>
      <div class="user-avatar flex">
        <img :src="steamAvatarImage(profile.avatar)" alt="avatar">
      </div>
    </BamLink>

    <div v-if="logged" class="nav-wrapper">
      <BamLink :to="market_link" class="link">
        {{ $t('body.market') }}
      </BamLink>

      <BamLink :to="ROUTE.bs_inventory" class="link">
        <span>{{ $t('account.inventory') }}</span>
      </BamLink>

      <BamLink :to="{ name: ROUTE.steam_inventory }" class="link">
        <span>{{ $t('market.sell') }}</span>
      </BamLink>

      <BamLink v-if="status.buy_order" :to="ROUTE.buy_orders" class="link">
        <span>{{ $t('market.buy_orders') }}</span>
      </BamLink>

      <BamLink v-if="store_to" :to="store_to" class="link">
        <span>{{ $t('account.my_store') }}</span>
      </BamLink>

      <BamLink :to="ROUTE.transactions" class="link">
        <span>{{ $t('account.transactions') }}</span>
      </BamLink>

      <BamLink :to="ROUTE.profile" class="link">
        <span><span>{{ $t('account.settings') }}</span></span>
      </BamLink>

      <BamLink :to="ROUTE.support" class="link">
        <span>{{ $t('common.support') }}</span>
      </BamLink>

      <button class="link" @click="() => onLogout()">
        <span>{{ $t('account.logout') }}</span>
      </button>
    </div>

    <TheFooter />
  </div>
</template>

<script setup>
import GameSelect from '@/component/body/GameSelect.vue';
import TheFooter from '@/component/body/TheFooter.vue';
import HotNotify from '@/component/body/HotNotify.vue';
import { steam_down, steam_down_hide, status } from '@/hook/status.js';
import { hot_notify_enabled, hot_notify_visible } from '@/hook/system/hot_notify.js';
import { pushRoute } from 'bambam-bus';
import { ROUTE } from '@/facade/enum.js';
import BamLink from 'bambam-router/component/BamLink.vue';
import { market_link } from '@/hook/market/game.js';
import { session } from '@/main.js';
import { store_to } from '@/hook/profile/profile.js';
import { steamAvatarImage } from '@/helper/steam.js';
import { defineAsyncComponent, watch } from 'vue';
import { useRoute } from 'vue-router';
import { unescapeNickname } from '@/helper/user.js';

const SteamDown = defineAsyncComponent(() => import('@/component/body/SteamDown.vue'));

const { onLogout, profile, logged } = session;

const emit = defineEmits(['close']);

const handleClose = () => {
  emit('close');
};

const route = useRoute();
watch(route, () => {
  handleClose();
});
</script>
